import { FormErrorFocus } from 'components';
import { useTranslation } from 'libs/i18n';
import { DocumentsTableFeature } from 'modules/client/common/feature';

import { Owner } from './Owner';
import { Representative } from './Representative';

export const FormContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <FormErrorFocus />
      <Owner />
      <Representative />
      <DocumentsTableFeature
        maxDocumentCount={1}
        name="companySignedClientServiceAgreementFiles"
        title={t('client.createClient.contract')}
        titleVariant="subtitle"
      />
      <DocumentsTableFeature
        maxDocumentCount={1}
        name="companySignedNoticeOfInvestmentAccountOpeningFiles"
        title={t(
          'client.createClient.companySignedNoticeOfInvestmentAccountOpening'
        )}
        titleVariant="subtitle"
      />
    </>
  );
};
